import {
  IsNotEmpty,
  Max,
  Min,
  IsInt,
} from 'class-validator';

export class UserMacroGoalsEntryModel {
  @IsNotEmpty({ message: 'Calories is required' })
  @IsInt({ message: 'Calories must be a whole number' })
  @Min(1, { message: 'Valid range for Calories is between 1 and 10,000' })
  @Max(10000, { message: 'Valid range for Calories is between 1 and 10,000' })
  public calories: number;
  @IsNotEmpty({ message: 'Carbs is required' })
  @IsInt({ message: 'Carbs must be a whole number' })
  @Min(0, { message: 'Valid range for Carbs is between 0 and 1,000' })
  @Max(1000, { message: 'Valid range for Carbs is between 0 and 1,000' })
  public carbs: number;
  @IsNotEmpty({ message: 'Alcohol is required' })
  @IsInt({ message: 'Alcohol must be a whole number' })
  @Min(0, { message: 'Valid range for Alcohol is between 0 and 1,000' })
  @Max(1000, { message: 'Valid range for Alcohol is between 0 and 1,000' })
  public alcohol: number;
  @IsNotEmpty({ message: 'Fat is required' })
  @IsInt({ message: 'Fat must be a whole number' })
  @Min(0, { message: 'Valid range for Fat is between 0 and 1,000' })
  @Max(1000, { message: 'Valid range for Fat is between 0 and 1,000' })
  public fat: number;
  @IsNotEmpty({ message: 'Protein is required' })
  @IsInt({ message: 'Protein must be a whole number' })
  @Min(0, { message: 'Valid range for Protein is between 0 and 1,000' })
  @Max(1000, { message: 'Valid range for Protein is between 0 and 1,000' })
  public protein: number;

  constructor(calories: number, carbs: number, alcohol: number, fat: number, protein: number) {
    this.calories = calories;
    this.carbs = carbs;
    this.alcohol = alcohol;
    this.fat = fat;
    this.protein = protein;
  }
}
